app.mediator.registerModule(MODULE_NAME__CONTACT_FORM, function (app) {

    var dataStore = app.data;
    var entrySubjectValue = 'myEntry';
    var productEnquirySubjectValue = 'productEnquiry';

    return {

        // The jQuery DOM element that is the register form
        $formElem: null,

        // The JDA validator object - a wrapper around validateJS. Created on init().
        jdaValidator: null,

        useGreCaptcha: false,
        grecaptchaLoaded: false,
        grecaptchaId: null,

        isDomLoaded: false,
        isCaptchaScriptLoaded: false,

        //==========================================================xdiv2====
        // Start and stop
        //===================================================================

        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
                this.isDomLoaded = true;
            }
            if (data.hasJustLoaded(RESOURCE_NAME__GOOGLE_RECAPTCHA)) {
                this.useGreCaptcha = true;
                this.isCaptchaScriptLoaded = true;
            }
            if (!this.grecaptchaLoaded && this.isDomLoaded && this.isCaptchaScriptLoaded) {
                if ((!this.$formElem) || (!this.$formElem.length)) return;
                this.grecaptchaLoaded = true;
                this.grecaptchaId = app.helpers.funcs.protectFormInvisibleCaptcha(this.$formElem);
            }
        },

        init: function() {

            // Init
            var scope = this;

            // Prepare data for creation of jda validator instance
            var constraints = dataStore.get('validation.contactForm');
            this.$formElem = $('#form-contact-us');

            // Don't bother to add the event listeners if the form DOM element does not exist
            // i.e. We are on another page. This will save memory.
            if (!this.$formElem.length) return;

            // Create jda validator instance
            this.jdaValidator = app.validator.build({}, this.$formElem);

            // Add constraints data to validator
            this.jdaValidator.constraintBag.addConstraints(constraints);

            this.$formElem.find('input[type=password], input[type=text], textarea').keyup(function(e) {
                if (scope.jdaValidator.configuration.keyUpShouldBeIgnored(e)) return;
                var $elem = $(this);
                var name = $elem.attr('name');
                scope.handleElemChange($elem);
            });
            this.$formElem.find('select, input[type=checkbox], input[type=radio]').change(function() {
                var $elem = $(this);
                var name = $elem.attr('name');
                scope.handleElemChange($elem);
                if (name == 'subject') {
                    var val = $(this).val();
                    if (val === entrySubjectValue) {
                        scope.showEntryDetailsInput();
                        scope.hideProductEnquiryInfo();
                        scope.showFormMainBody();
                    } else if (val === productEnquirySubjectValue) {
                        scope.showProductEnquiryInfo();
                        scope.hideEntryDetailsInput();
                        scope.hideFormMainBody();
                    } else {
                        scope.hideEntryDetailsInput();
                        scope.hideProductEnquiryInfo();
                        scope.showFormMainBody();
                    }
                }
            });

            this.$formElem.submit(function(e) {
                scope.handleFormSubmit(e);
            });

            app.mediator.notify(EVENT_NAME__CONTACT_FORM__INITIATED);
        },

        //==========================================================xdiv2====
        // DOM event handlers
        //===================================================================

        handleFormSubmit: function(e) {

            var grecaptchaVal = null;

            if (this.useGreCaptcha) {
                grecaptchaVal = this.$formElem.find('[name="g-recaptcha-response"]').val();
                if (!this.grecaptchaLoaded) {
                    e.preventDefault();
                    var fallbackError = 'Please wait for the page to load before submitting the form.';
                    var error = window.serverData.generalLanguageStrings.captchaNotReady || fallbackError;
                    app.ui.uiPlugins.toast.fire(error, 'danger');
                    return;
                }
            }

            var messageBag = this.jdaValidator.getMessageBag();
            this.jdaValidator.presenter.clearStatuses();
            this.jdaValidator.presenter.showStatuses(messageBag);
            if (messageBag.hasMessages()) {
                e.preventDefault();
                this.jdaValidator.presenter.scrollToFirstError();
            } else {
                if (this.useGreCaptcha && !grecaptchaVal) {
                    e.preventDefault();
                    app.ui.uiPlugins.toast.fire('Please complete the CAPTCHA before submitting this form.', 'danger');
                }
            }
        },

        handleElemChange: function($elem) {
            var formFieldId = this.jdaValidator.configuration.getFormFieldId($elem);
            var messageBag = this.jdaValidator.getMessageBagForFormField(formFieldId);
            this.jdaValidator.presenter.clearStatus($elem);
            this.jdaValidator.presenter.showStatus($elem, messageBag);
        },

        //==========================================================xdiv2====
        // Mediator event handlers
        //===================================================================

        // None yet

        //==========================================================xdiv2====
        // Module
        //===================================================================

        getEntryInputWrap: function() {
            if ($('.wrap-entry-id').length === 1) {
                return $('.wrap-entry-id');
            } else {
                return $('.wrap-entry-title');
            }
        },

        getProductEnquiryInfoWrap: function() {
            return $('.wrap-product-enquiry-info');
        },

        getFormMainBodyWrap: function() {
            return $('#wrap-form-main-body-id');
        },

        showEntryDetailsInput: function() {
            var $wrapElem = this.getEntryInputWrap();
            $wrapElem.removeClass('hidden');
        },

        hideEntryDetailsInput: function() {
            var $wrapElem = this.getEntryInputWrap();
            $wrapElem.addClass('hidden');
        },

        showProductEnquiryInfo: function () {
            var $wrapElem = this.getProductEnquiryInfoWrap();
            $wrapElem.removeClass('hidden');
        },

        hideProductEnquiryInfo: function () {
            var $wrapElem = this.getProductEnquiryInfoWrap();
            $wrapElem.addClass('hidden');
        },

        showFormMainBody: function() {
            var $wrapElem = this.getFormMainBodyWrap();
            $wrapElem.removeClass('hidden');
        },

        hideFormMainBody: function () {
            var $wrapElem = this.getFormMainBodyWrap();
            $wrapElem.addClass('hidden');
        }
    };
});